import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbDown = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14 9H9V20H14",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14 20L17 31C17.7956 31 18.5587 30.6839 19.1213 30.1213C19.6839 29.5587 20 28.7956 20 28V22H27.5C27.9325 22 28.3599 21.9064 28.7529 21.7258C29.1459 21.5451 29.4951 21.2817 29.7767 20.9534C30.0584 20.6251 30.2657 20.2399 30.3845 19.824C30.5033 19.4081 30.5307 18.9715 30.465 18.544L29.388 11.544C29.2792 10.8362 28.9207 10.1907 28.3775 9.72418C27.8343 9.25762 27.1421 9.00075 26.426 9H14V20Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgThumbDown);
export default ForwardRef;
